import styled from "styled-components";

export const Container = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;

    img{
        width: 100%;
        height: 100%;
    }
`;